export default __webpack_public_path__ + "static/media/tts-config.2338203c.webp";